// Desc: generic state for for pcb assembly
import { START } from 'pu-data/QuoteSteps';
import defaultParameters from 'us_pcb_assembly/data/defaultParameters';
import defaultQuote from 'us_pcb_assembly/data/defaultQuote';
import defaultSuppliers from 'us_pcb_assembly/data/defaultSuppliers';
import { USA_PCB_ASSEMBLY_ID } from 'product_tabs/tab_assembly/data/productVariants';

export default {
  loading: false,
  parameters: defaultParameters,
  parametersChanged: false,
  suppliers: defaultSuppliers,
  quoteStep: START,
  quote: defaultQuote,
  currentVariant: USA_PCB_ASSEMBLY_ID,
  lineItemId: null,
}
